<script>
    export let items = [];
</script>

<style>
</style>

<div class="sticky-top-bar border-bottom bg-gray-100 py-2 px-3 d-flex justify-content-between flex-wrap">
    <ul class="nav nav-pills">
        {#each items as item}
            <li class="nav-item">
                {#if item.url}
                    <a class:active={item.active} class="nav-link" href="{item.url}">{item.name}</a>
                {:else}
                    <a class:active={item.active} class="nav-link" href="#" on:click={item.action}>{item.name}</a>
                {/if}
            </li>
        {/each}
    </ul>
</div>
